export enum DECLARATION_PERIOD_STATUS {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  PENDING = 'PENDING',
}

export enum DECLARATION_TYPE {
  TAX = 'TAX',
  SOCIAL = 'SOCIAL',
}

export enum DECLARATION_STATUS {
  NOT_DECLARED = 'NOT_DECLARED',
  DECLARED = 'DECLARED',
  PAID = 'PAID',
}

export enum TAX_DECLARATION_STATUS {
  NOT_DECLARED = 'NOT_DECLARED',
  DECLARED = 'DECLARED',
  PAID = 'PAID',
}

/** Maps DGI form / legacy numeric codes to TAX_DECLARATION_STATUS */
export const TAX_DECLARATION_STATUS_MAP = new Map<string, TAX_DECLARATION_STATUS>([
  ['0', TAX_DECLARATION_STATUS.NOT_DECLARED],
  ['1', TAX_DECLARATION_STATUS.DECLARED],
  ['2', TAX_DECLARATION_STATUS.DECLARED],
  ['3', TAX_DECLARATION_STATUS.PAID],
  ['4', TAX_DECLARATION_STATUS.DECLARED],
  ['5', TAX_DECLARATION_STATUS.DECLARED],
]);

export enum CNPS_DECLARATION_STATUS {
  NOT_DECLARED = 'NOT_DECLARED',
  DECLARED = 'DECLARED',
  PAID = 'PAID',
}
